import { useQuery } from "react-query";
import { getClasses } from "../services/school/class/getClasses";
import { PagedRequestType } from "../types/PagedResults";
import { GET_MONTHSPAYMENTS, Key_classes, Key_studentdebties, Key_studentTotals } from "../utils/constants";
import { getIrregularStudentDebt, getIrregularStudentDebtByStudentsClass, getMonthPayments, getStudentDebt, getStudentDebtTotalByStudentId } from "../services/finance/studentDebt";
import { StudentPaymentReportQueryType } from "../types/Finance";

export const useGetStudentDebtiesQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_studentdebties, JSON.stringify(data)],
    () => getStudentDebt(data),
    options? {...options}:{}

  );

export const useGetIrregularStudentDebtiesQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_studentdebties, JSON.stringify(data)],
    () => getIrregularStudentDebt(data),
    options? {...options}:{}

  );

  export const useGetIrregularStudentDebtiesByStudentsClassQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_studentdebties, JSON.stringify(data)],
    () => getIrregularStudentDebtByStudentsClass(data),
    options? {...options}:{}

  );

  export const useGetStudentDebtsTotalByStudentIdQuery = (id:any, options: any = null) =>
    useQuery(
      [Key_studentTotals, JSON.stringify(id)],
      () => getStudentDebtTotalByStudentId(id),
      options? {...options}:{}
  
    );

    export const useGetMonthPayments = (data:StudentPaymentReportQueryType, options: any = null) =>
  useQuery(
    [GET_MONTHSPAYMENTS, JSON.stringify(data)],
    () => getMonthPayments(data),
    options? {...options}:{}

  );